import { screenBorderWidth } from 'src/components/assemblyScreen/AssemblyScreen.styled';

export const getLayoutScreenMaxWidth = (
  totalWidth: number,
  screensCount: number,
) => {
  const totalBorderWidth = screenBorderWidth * (screensCount + 1);

  return (totalWidth - totalBorderWidth) / screensCount;
};

export const getScaleByModalWidth = (
  width: number,
  height: number,
  screenMaxWidth: number,
  screenMaxHeight: number,
) => Math.min(screenMaxWidth / width, screenMaxHeight / height);
